export const IMPORT_LABEL = { yolda: "Yolda", gumrukte: "Limana Ulaştı / Gümrükte", eksik: "Eksik Ürün / Gümrük Bekliyor", tamamlandi: "Tamamlandı", bloke: "Sorun / Bloke" };
export const IMPORT_TONE = {
  yolda: "bg-blue-50 text-blue-700 border-blue-200", gumrukte: "bg-violet-50 text-violet-700 border-violet-200", eksik: "bg-amber-50 text-amber-800 border-amber-300",
  tamamlandi: "bg-emerald-50 text-emerald-700 border-emerald-200", bloke: "bg-rose-50 text-rose-700 border-rose-300",
};
export const ROW_TONE = { yolda: "border-l-blue-500", gumrukte: "border-l-violet-500", eksik: "border-l-amber-400", tamamlandi: "border-l-emerald-500", bloke: "border-l-rose-500" };
const DOT = { yolda: "bg-blue-500", gumrukte: "bg-violet-500", eksik: "bg-amber-400", tamamlandi: "bg-emerald-500", bloke: "bg-rose-500" };

export const ImportBadge = ({ status, testid }) => (
  <span className={`inline-flex items-center gap-1 text-[11px] font-medium px-1.5 py-0.5 rounded border whitespace-nowrap ${IMPORT_TONE[status] || "bg-slate-50 border-slate-200"}`} data-testid={testid}>
    <span className={`h-2 w-2 rounded-full ${DOT[status] || "bg-slate-400"}`} />{IMPORT_LABEL[status] || status}
  </span>
);

const LINE_TONE = { alindi: "text-emerald-700", kismi: "text-orange-600", bekliyor: "text-amber-700" };
const LINE_ICON = { alindi: "✓", kismi: "◐", bekliyor: "○" };
export const LineBadge = ({ s, label }) => <span className={`text-[11px] font-medium whitespace-nowrap ${LINE_TONE[s]}`}>{LINE_ICON[s]} {label}</span>;

export const Progress = ({ p, testid }) => (
  <div className="min-w-[140px]" data-testid={testid}>
    <div className="text-[11px] text-slate-600 font-mono">{p.label}</div>
    <div className="h-1.5 bg-slate-100 rounded mt-0.5 overflow-hidden"><div className={`h-full ${p.pct >= 100 ? "bg-emerald-500" : "bg-amber-400"}`} style={{ width: `${Math.min(p.pct, 100)}%` }} /></div>
  </div>
);
